export const meetingsI18n = {
  en:{
    common:{
      actionNo:'No',
      actionYes:'Yes'
    },
    homeMeetings: {
      selectMembers: 'Select members',
      membersSelected: 'Members selected',
      members: 'Members',
      meetings: 'Present',
      createMeeting: 'Create new present',
      createMeetingTitle: 'Create present',
      editMeetingTitle: 'Edit present',
      confirmRemove: 'Are you sure you want to delete this present?',
      confirmRemoveMeetingStarted: 'Are you sure you want to delete this present? (No more users would be able to join this present.)',
      emptyMeetings: 'You don\'t have present assigned',
      errorCreatingMeetingTitle: 'Ops!',
      errorCreatingMettingBody: 'There was an error trying to save the info of the present. Try again please.',
      successCreatingMeetingTitle: 'Present created',
      successCreatingMettingBody: 'Your present was saved successfully',
      errorEnteringMeetingBody: 'There was an error trying to enter the present. Try again please.',
      meetingDetailsTitle: 'Present details',
      noClasses: 'You don\'t have any classes available',
      joinMeeting: 'Join present',
      errorLoading: 'There was an error loading your request, please try again later.',
    },
    customizeGroups:{
      customize:'Customize',
      title:'Rooms Manager',
      subtitleRooms:'Present Rooms',
      subtitleGroups:'Groups',
      subtitleAvailable:'Available Students',
      students:'Students',
      tooltip: 'You can add students from the \'Available Students\' section. Find the student you want to add to a group, then click on the student\'s name, and drag it to the desired group',
      actionCancel:'No',
      actionAccept:'Yes',
      noStudents:'No students available',
      noGroups:'No groups created',
      deleteGroupMsg1:'There are students assigned in this group. Are you sure you want to delete it?',
      deleteSetMsg1:'There are students assigned in this set. Are you sure you want to delete it?',
      selectNewNameTitle:'Choose a new name',
      selectNewNameGroupMsg:'The group name you entered is already being used. Please choose a different one.',
      selectNewNameSetMsg:'The set name you entered is already being used. Please choose a different one.',
      removeActiveGroupMsg:'Are you sure you want to remove this group?. Once this group is deleted the \'All\' set will become active.',
      removeActiveSetMsg:'Are you sure you want to remove this set?. Once this set is deleted the \'All\' set will become active.',
      removeStudentMsg:'This is the last student in this set, if you remove it the \'All\' set will become active.',
      invalidNameTitle:'Missing Name',
      invalidNameMsg:'Please enter a valid name',
      activeSet:'Active set',
      setsHelpText1:'Please choose the present you\'d like to activate',
      setsHelpText2:'Only the present with a group and student setup will be activated',
      setName:'Set name',
      groupName:'Group name',
      noMeetingAvailable: 'This present isn\'t available at the moment, please try again later.',
      genericError: 'An error has ocurred trying to load the page.',
      errorTitle:'Error'
    },
    waitingRoom:{
      inThisMeeting: 'In this present',
      waitingForHostMsg: 'Waiting for the host to start the present',
      reloading: 'Loading, please wait...',
      manualReload: 'Try to join',
      hostNotReady: 'The host hasn\'t joined yet',
      hostText: '(Host)',
      noLongerMember:'The present has been deleted or changed.',
      successTitle:'Success',
      successEnteringMeeting:'The teacher has joined the room'
    },
    viewer: {
      response: 'Response',
      noContent: 'No content',
      openInNewWindow: 'Open in a new window',
      openInCourse: 'Open section of the subject',
      interactiveActivity: 'Interactive Activity',
    },
    presentationMode: {
      presentationMode: 'Presentation Mode',
      leaveTeacher: 'The teacher is not connected. <router-link :to="/p/portal/">Exit Presentation</router-link>',
      leaveTeacherWebView: 'The teacher is not connected',
      teacherNotSelectDocument: 'The teacher has not selected a document',
      autoplayDisabledTitle: 'Browser settings - Autoplay is disabled',
      autoplayDisabledMessage: 'Your browser has the autoplay setting for videos disabled. Accept to start the video',
      keepAllMarkups: 'Do you want to keep the markup done in the teacher\'s tasks for future sessions?',
      errorMessage: 'An error has occurred trying to load the presentation mode, please try <a href="javascript:location.reload()" style="text-decoration: underline;">again.</a>',
      autoplayAudioDisabledMessage: 'Your browser has the autoplay setting for audios disabled. Accept to start the audio',
      browserSettingTitle: 'Browser settings',
      audioPlayError: 'Please accept to play the media element.',
      noContent: 'There is no availabe content for the current user.',
      userBoardTitle: 'Watching {username}\'s Task',
      teacherBoardTitle: 'The teacher is presenting',
      share: 'Share',
      showAll: 'Show All',
      showOnlineOnly: 'Show Online Only',
      on: 'Enable to go back to sharing',
      off: 'Disable to browse other objects without changing the student\'s task',
      navigation: 'Navigation',
      teacherAsGuest: 'The Teacher {name} is presenting this class, do you want to join as a guest?',
      otherUserSession: 'You\'re already presenting this class on another device or browser.',
      otherUserSessionDetails: 'Presentation started on {date}\n from the following device: {device}.',
      guestTeacherJoined: 'The Teacher {name} has joined the session as a guest.',
      screenShareConfirmation: 'Are you sure you want to share your screen?',
      screenShareConnectionInterruptedError: 'Video transfering connection was interrupted',
      teacherStoppedSharing: 'The Teacher has stopped sharing.',
      hostTeacherLeftSession: 'The host teacher has left the session. Do you want to assume the role as the host of this session?'
    },
    lesson: {
      courseEmpty: 'You don\'t have content in this section',
    }
  },
  es:{
    common:{
      actionNo:'No',
      actionYes:'Si'
    },
    homeMeetings: {
      selectMembers: 'Seleccionar miembros',
      membersSelected: 'Miembros seleccionados',
      members: 'Miembros',
      meetings: 'Reuniones',
      createMeeting: 'Crear nueva reunión',
      createMeetingTitle: 'Crear reunión',
      editMeetingTitle: 'Editar reunión',
      confirmRemove: '¿Está seguro que quiere eliminar ésta reunión?',
      confirmRemoveMeetingStarted: '¿Está seguro que quiere eliminar ésta reunión? (ningún usuario podrá unirse a ésta reunión)',
      emptyMeetings: 'No tienes reuniones asignadas',
      errorCreatingMeetingTitle: 'Ops!',
      errorCreatingMettingBody: 'Hubo un error intentando guardar la información de la reunión. Por favor intenta de nuevo.',
      successCreatingMeetingTitle: 'Reunión creada',
      successCreatingMettingBody: 'Tu reunión fue guardada exitosamente.',
      meetingDetailsTitle: 'Detalles de la reunión',
      noClasses: 'No tienes clases disponibles',
      joinMeeting: 'Unirse a la reunión',
      errorLoading: 'Ocurrió un error al generar la petición, por favor intente más tarde.',
    },
    customizeGroups:{
      customize:'Personalizar',
      title:'Administrador de salas',
      subtitleRooms:'Salas de Encuentro',
      subtitleGroups:'Grupos',
      subtitleAvailable:'Estudiantes Disponibles',
      students:'Estudiantes',
      tooltip: 'Puedes añadir estudiantes desde la sección \'Estudiantes Disponibles\'. Encuentra al estudiante que quieres añadir al grupo, dale click y arrástralo al grupo que desees',
      actionCancel:'No',
      actionAccept:'Si',
      noStudents:'No hay estudiantes disponibles',
      noGroups:'No hay grupos creados',
      deleteGroupMsg1:'Hay estudiantes asignados a éste grupo. Está seguro de que desea eliminarlo?',
      deleteSetMsg1:'Hay estudiantes asignados a ésta sala. Está seguro de que desea eliminarla?',
      selectNewNameTitle:'Elija un nuevo nombre',
      selectNewNameGroupMsg:'El nombre de grupo que ingresó está siendo utilizado actualmente. Por favor elija uno distinto.',
      selectNewNameSetMsg:'El nombre de sala que ingresó está siendo utilizado actualmente. Por favor elija uno distinto.',
      removeActiveGroupMsg:'Está seguro que desea eliminar éste grupo?. Una vez éste grupo sea eliminado la sala \'All\' se activará.',
      removeActiveSetMsg:'Está seguro que desea eliminar ésta sala?. Una vez ésta sala sea eliminada la sala \'All\' se activará.',
      removeStudentMsg:'Éste es el último estudiante de ésta sala, si lo eliminas la sala \'All\' se activará.',
      invalidNameTitle:'Falta Nombre',
      invalidNameMsg:'Por favor ingrese un nombre válido.',
      activeSet:'Sala activa',
      setsHelpText1:'Por favor escoge la reunión que te gustaría activar',
      setsHelpText2:'Solo la reunión que tenga grupo y estudiante asociado podrá activarse',
      setName:'Nombre de la sala',
      groupName:'Nombre del grupo',
      noMeetingAvailable: 'Ésta reunión no está disponible actualmente, por favor intenta más tarde.',
      genericError: 'Ha ocurrido un error tratando de cargar la página.',
      errorTitle:'Error'
    },
    waitingRoom:{
      inThisMeeting: 'En ésta reunión',
      waitingForHostMsg: 'Esperando a que el anfitrión empiece la reunión',
      reloading: 'Cargando, por favor espere...',
      manualReload: 'Volver a cargar',
      hostNotReady: 'El anfitrión aun no se ha unido',
      hostText: '(Anfitrión)',
      noLongerMember:'La reunión ha sido modificada o eliminada.',
      successTitle:'Éxito',
      successEnteringMeeting:'El profesor se ha unido a la reunión'
    },
    viewer: {
      response: 'Respuesta',
      noContent: 'No hay contenido',
      openInNewWindow: 'Abrir en una nueva ventana',
      openInCourse: 'Abrir sección en el curso',
      interactiveActivity: 'Tarea',
    },
    presentationMode: {
      presentationMode: 'Modo Presentación',
      leaveTeacher: 'El profesor no está conectado. <a href="/eduac/p/portal" style="text-decoration: underline;">Salir</a>',
      leaveTeacherWebView: 'El profesor no está conectado.',
      teacherNotSelectDocument: 'El profesor no ha seleccionado un documento',
      autoplayDisabledTitle: 'El autoplay está deshabilitado',
      autoplayDisabledMessage: 'El navegador tiene la configuración de autoplay deshabilitada. Debe dar click en Aceptar para iniciar el video',
      keepAllMarkups: '¿Desea mantener las anotaciones realizadas en las tareas del profesor para próximas sesiones?',
      errorMessage: 'Se ha producido un error al intentar cargar el modo de presentación, inténtalo <a href="javascript:location.reload()" style="text-decoration: underline;">de nuevo.</a>',
      autoplayAudioDisabledMessage: 'El navegador tiene la configuración de autoplay deshabilitada. Debe dar click en Aceptar para iniciar el audio',
      browserSettingTitle: 'Configuración del navegador',
      audioPlayError: 'Por favor acepta para reproducir el elemento multimedia',
      noContent: 'No hay contenido disponible para el usuario actual.',
      userBoardTitle: 'Observando la tarea de {username}',
      teacherBoardTitle: 'El profesor está presentando',
      share: 'Compartir',
      showAll: 'Ver todos',
      showOnlineOnly: 'Ver conectados',
      on: 'Activar para compartir',
      off: 'Deshabilitar para buscar otros objetos sin cambiar la tarea del estudiante',
      navigation: 'Navegación',
      teacherAsGuest: 'El Profesor {name} está presentando esta clase, ¿quieres unirte como invitado?',
      otherUserSession: 'Ya estás presentando esta clase en otro dispositivo o navegador.',
      otherUserSessionDetails: 'La presentación inició el {date}\n desde el siguiente dispositivo: {device}.',
      guestTeacherJoined: 'El Profesor {name} se ha unido a la sesión como invitado.',
      screenShareConfirmation: '¿Desea compartir su pantalla?',
      screenShareConnectionInterruptedError: 'La conexión de transferencia de video fue interrumpida.',
      teacherStoppedSharing: 'El profesor ha dejado de compartir.',
      hostTeacherLeftSession: 'El profesor anfitrión ha abandonado la sesión. ¿Quiere asumir el papel de anfitrión de esta sesión?'
    },
    lesson: {
      courseEmpty: 'Aún no tienes contenido en esta sección'
    }
  }
};